import Component from '../../../shared/component';

export default class AvatarBuilderMobileSaveControl extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);

    this.$saveControl = this.$element.children(
      '.menteeAvatarBuilderModal-header-controls-link--save'
    );
    this.$loadingMessage = this.$element.children(
      '.menteeAvatarBuilderModal-header-controls-link--loading'
    );
    this.$savedMessage = this.$element.children(
      '.menteeAvatarBuilderModal-header-controls-link--saved'
    );

    this.avatarBuilder = opts.avatarBuilder;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$saveControl.on(
      'click.AvatarBuilderMobileSaveControl',
      this.handleClick
    );
  }

  unbindEvents() {
    this.$saveControl.off(
      'click.AvatarBuilderMobileSaveControl',
      this.handleClick
    );
  }

  handleClick() {
    if (this.avatarBuilder.previewMode === 'live') this.displayLoading();
    this.avatarBuilder.updateConfiguration();
  }

  handleSaved() {
    this.displaySaved();
  }

  displayReady() {
    this.$saveControl.show();
    this.$savedMessage.hide();
    this.$loadingMessage.hide();
  }

  displayLoading() {
    this.$saveControl.hide();
    this.$savedMessage.hide();
    this.$loadingMessage.show();
  }

  displaySaved() {
    this.$saveControl.hide();
    this.$savedMessage.show();
    this.$loadingMessage.hide();
  }

  hideLoading() {
    this.$loadingMessage.hide();
  }
}
